import { trackSelfDescribingEvent, Schema } from '@tourlane/tracking';

export interface ComponentEventData {
  action: string;
  atom: string;
  label: string;
  molecule: string;
}

/**
 * Snowplow is only bootstrapped in deployed environments (SnowplowScript in
 * index.tsx), and the tracking library calls window.snowplow() without
 * checking it exists — so locally every event throws. Fired from an event
 * handler that's just console noise; fired from a React effect it unmounts
 * the whole screen. Analytics must never take the join flow down, hence
 * both the environment guard and the catch.
 */
export function trackComponentEvent(pageType: string, data: ComponentEventData) {
  if (!process.env.REACT_APP_DEPLOYED_TO) return;
  try {
    trackSelfDescribingEvent({ pageType, event: { data, schema: Schema.COMPONENT_EVENT } });
  } catch {
    // Deliberately swallowed: a tracking failure is not the customer's problem.
  }
}
